import { __assign, __extends, __rest, __spreadArrays } from "tslib";
import React from 'react';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { moveGallection, removeGallection, setGallectionName, } from '../../actions';
import ItemControlButtons from '../ItemControlButtons';
import PencilIcon from '../../../Icons/Pencil';
import TrashcanIcon from '../../../Icons/Trashcan';
import MoveIcon from '../../../Icons/Move';
import { IconSize } from '../../../Icons/IconWrap';
import GallectionListMenu from '../GallectionListMenu';
import { TrashCan } from '../../../Icons/Confirmations';
import ConfirmationPopup from '../../../Popup/ConfirmationPopup';
import PromptPopup from '../../../Popup/PromptPopup';
import { getFolderNameValidationErrorMessage, MAX_TITLE_LENGTH, } from '../../../utils/isValidFolderName';
import { isGallectionManageable } from '../../helpers';
import { getSubfoldersByParentId, getFeaturedFolder } from '../../selectors';
import { withFeatureFlags } from '../../../redux/flags';
import { pushModal } from '../../../Modals/redux/basicActions';
import { ModalType } from '../../../Modals/redux/types';
import { connect } from 'react-redux';
import { changeGalleryId as changePortfolioGalleryId } from '../../../WixPortfolio/redux/actions';
import { getCurrentUserHasWixPortfolio } from '../../../publicSession';
import FolderSyncIcon from '../../../Icons/FolderSync';
var enhance = compose(connectMediaStore(function (state, ownProps) { return ({
    featuredFolder: getFeaturedFolder(state),
    hasSubfolders: getSubfoldersByParentId(state, ownProps.gallection.folderId).length > 0,
    hasWixPortfolio: getCurrentUserHasWixPortfolio(state),
}); }, function (dispatch) { return ({
    moveGallection: moveGallection,
    removeGallection: removeGallection,
    setGallectionName: setGallectionName,
}); }), connect(undefined, function (dispatch) { return ({
    openWixPortfolioModal: function (gallection) {
        dispatch(pushModal(ModalType.WIX_PORTFOLIO_CREATE, { wrapInPopup: false }));
        dispatch(changePortfolioGalleryId(gallection.folderId));
    },
}); }), withTranslation(), withFeatureFlags);
var GallectionControlButtons = /** @class */ (function (_super) {
    __extends(GallectionControlButtons, _super);
    function GallectionControlButtons() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            popupType: null,
        };
        _this.closePopup = function () {
            _this.setState({ popupType: null });
        };
        _this.openRemoveConfirmationPopup = function () {
            _this.setState({ popupType: 'remove' });
        };
        _this.openRenamePromptPopup = function () {
            _this.setState({ popupType: 'rename' });
        };
        _this.confirmRemove = function () {
            var props = _this.props;
            props.removeGallection(props.gallection.folderId);
            _this.closePopup();
        };
        _this.onValidateName = function (name) {
            var _a = _this.props, t = _a.t, existingGallectionNames = _a.existingGallectionNames;
            return getFolderNameValidationErrorMessage(name, t, existingGallectionNames);
        };
        _this.rename = function (name) {
            var folderId = _this.props.gallection.folderId;
            _this.props.setGallectionName({
                folderId: folderId,
                name: name,
            });
            _this.closePopup();
        };
        return _this;
    }
    GallectionControlButtons.prototype.render = function () {
        var _a = this.props, className = _a.className, moreMenuClassName = _a.moreMenuClassName, canMoveBack = _a.canMoveBack, canMoveForward = _a.canMoveForward, onMoveBack = _a.onMoveBack, onMoveForward = _a.onMoveForward, t = _a.t;
        return (React.createElement(React.Fragment, null,
            React.createElement(ItemControlButtons, { className: className, moreMenuClassName: moreMenuClassName, menuItems: [
                    {
                        // safe zone
                        items: [
                            {
                                value: 1,
                                label: t('mediapopup.itemMenu.rename'),
                                icon: React.createElement(PencilIcon, { size: IconSize.SMALL }),
                                onClick: this.openRenamePromptPopup,
                            },
                            this.getFolderMoveMenuItem(),
                            this.shouldShowPortfolioOption() &&
                                this.getPortfolioCreateMenuItem(),
                        ].filter(function (item) { return item; }),
                    },
                    {
                        // danger zone
                        items: [
                            {
                                value: 3,
                                label: t('mediapopup.itemMenu.delete'),
                                icon: React.createElement(TrashcanIcon, { size: IconSize.SMALL }),
                                danger: true,
                                onClick: this.openRemoveConfirmationPopup,
                            },
                        ],
                    },
                ], canMoveBack: canMoveBack, canMoveForward: canMoveForward, onMoveBack: onMoveBack, onMoveForward: onMoveForward }),
            this.renderPopup()));
    };
    GallectionControlButtons.prototype.shouldShowPortfolioOption = function () {
        var _a = this.props, gallection = _a.gallection, flags = _a.flags, hasWixPortfolio = _a.hasWixPortfolio;
        var isPortfolioFolderSyncEnabled = flags.includes('wix_portfolio_folder_sync');
        return (isPortfolioFolderSyncEnabled &&
            !gallection.isPortfolioLinked &&
            !hasWixPortfolio);
    };
    GallectionControlButtons.prototype.getPortfolioCreateMenuItem = function () {
        var _a = this.props, t = _a.t, openWixPortfolioModal = _a.openWixPortfolioModal, gallection = _a.gallection;
        return {
            label: t('wixPortfolio.folderSync.menuCreate'),
            icon: React.createElement(FolderSyncIcon, { size: IconSize.SMALL }),
            onClick: function () { return gallection && openWixPortfolioModal(gallection); },
        };
    };
    GallectionControlButtons.prototype.getFolderMoveMenuItem = function () {
        var _a = this.props, gallection = _a.gallection, featuredFolder = _a.featuredFolder, hasSubfolders = _a.hasSubfolders, t = _a.t, props = __rest(_a, ["gallection", "featuredFolder", "hasSubfolders", "t"]);
        return {
            label: t('mediapopup.itemMenu.moveFolderToOtherFolder'),
            icon: React.createElement(MoveIcon, { size: IconSize.SMALL }),
            disabled: !isGallectionManageable(gallection) ||
                // we do not allow more than 1 level of nesting
                // so disallow moving a folder that already has subfolders
                // into another folder
                hasSubfolders,
            submenu: (React.createElement(GallectionListMenu, { onlyTopLevelFolders: true, disableFolderIds: __spreadArrays([
                    gallection.folderId,
                    gallection.parentId
                ], (featuredFolder ? [featuredFolder.folderId] : [])), onSelect: function (toFolderId) {
                    return props.moveGallection({
                        folderId: gallection.folderId,
                        toFolderId: toFolderId,
                    });
                } })),
        };
    };
    GallectionControlButtons.prototype.renderPopup = function () {
        var _a = this.props, gallection = _a.gallection, t = _a.t;
        var popupType = this.state.popupType;
        if (!popupType) {
            return null;
        }
        if (popupType === 'rename') {
            return (React.createElement(PromptPopup, { isOpen: true, title: t("mediapopup.gallectionMenu." + gallection.type + ".prompt.rename.title"), inputLabel: t("mediapopup.gallectionMenu." + gallection.type + ".prompt.rename.label"), onInputValidate: this.onValidateName, initialInputValue: gallection.name, onCancel: this.closePopup, doneButtonLabel: t('mediapopup.rename'), onDone: this.rename, maxLength: MAX_TITLE_LENGTH }));
        }
        var typeToPropsMap = {
            remove: {
                title: t("mediapopup.gallectionMenu." + gallection.type + ".confirm.delete.title"),
                text: t("mediapopup.gallectionMenu." + gallection.type + ".confirm.delete.text"),
                confirmBtnLabel: t('mediapopup.itemMenu.delete'),
                confirmBtnType: 'danger',
                icon: React.createElement(TrashCan, null),
                onConfirm: this.confirmRemove,
            },
        };
        return (React.createElement(ConfirmationPopup, __assign({ isOpen: true, onCancel: this.closePopup }, typeToPropsMap[popupType])));
    };
    return GallectionControlButtons;
}(React.Component));
export { GallectionControlButtons };
export default enhance(GallectionControlButtons);
//# sourceMappingURL=GallectionControlButtons.connected.js.map